import { Injectable } from '@angular/core';

import { ISnScrollConfig } from './scroll.interfaces';
import { SnScrollReference } from './scroll.reference';

@Injectable({ providedIn: 'root' })
export class SnScrollService {
  private readonly _references = new Map<string, SnScrollReference>();

  constructor() {}

  public create(
    name: string,
    container: HTMLElement | Document,
    config?: ISnScrollConfig,
  ): SnScrollReference {
    if (!name) {
      throw Error('SnScroll must have a name');
    }

    const scroll = new SnScrollReference(container, config);
    this._references.set(name, scroll);

    return scroll;
  }

  public remove(name: string): void {
    const scroller = this._references.get(name);

    if (scroller) {
      scroller.destroy();
      this._references.delete(name);
    }
  }

  public connect(name: string): SnScrollReference {
    if (this._references.has(name)) {
      return this._references.get(name);
    }

    throw Error(`SnScroll with name ${name} not found`);
  }
}
